var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"factory__line",on:{"click":function($event){_vm.setfeaturedfactory(_vm.factory.id)}}},[_c('span',[_vm._v(_vm._s(_vm.factory.business_name))]),_vm._v(" "),(_vm.factory.preferred)?_c('i',{staticClass:"material-icons"},[_vm._v("stars")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf2c61a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainpage/FactoryLine.vue
// module id = null
// module chunks = 